/*  */

import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom"

import { Button, Drawer } from "antd";
import { Image } from "antd";
import ModalCustom from "./ModalCustom";
import ModalSucces from "./ModalSuccess";
import GetCurrentPoint from "../profile/GetCurrentPoint";
import { WordBookAnswerView, WordBookAllView, wordBookAnswe, WordBookAnswer } from "services/Api/Module/WordBook";
import _ from "lodash";
import heart from "../../assets/imgage/wordBook/ico-heart.svg"

const WordBookQuizAnswer = () => {
    const [open, setOpen] = useState(false);
    const [openPopup, setOpenPopup] = useState(false);
    const [openPopupError, setOpenPopupError] = useState(false);
    const [openPopupSuccess, setOpenPopupSuccess] = useState(false);
    const [tootip, setTootip] = useState(false);
    const navigate = useNavigate();
    const stateProfile = useSelector((state) => state.profile.dataUser);
    const stateCurrentPoint = useSelector((state) => state.currentPoint);
    const redeemHeart = stateCurrentPoint.redeemHeart;
    const newCurrentHeart = redeemHeart ? 10 : stateCurrentPoint.currentHeart;
    const customerId = stateProfile.id;
    const [wordBookAll, setWordBookAll] = useState([]);
    const [wordBookData, setWordBookData] = useState([]);
    const [questionData, setQuestionData] = useState([]);
    const [questionAnswer, setQuestionAnswer] = useState([]);
    const [answerData, setAnswerData] = useState([]);
    const [pointType, setPointType] = useState('heart');
    const [pointEarn, setPointEarn] = useState(0);
    const [isAns, setIsAns] = useState(false);


    let [searchParams, setSearchParams] = useSearchParams();
    const quizId = searchParams.get("id");
    let [searchParams2, setSearchParams2] = useSearchParams();
    const currentPage = searchParams2.get("page");



    useEffect(() => {
        fetchWordBookQuizView();
        document.documentElement.scrollTop = 0;
    }, []);

    const getWordBookQuizView = async () => {
        let _return = {
            status: false,
            result: {},
            rowCount: 0,
        };
        try {
            const { data } = await WordBookAnswerView({
                wordBookQuizId: quizId,
            });
            if (data.resultCode === "20000") {
                const resData = data.resultData;

                _return.status = true;
                _return.result = resData;
                _return.rowCount = data.rowCount;
            } else {
                navigate("/word-book-main");
            }
        } catch (e) {
            console.log(e);
            return _return;
        }
        return _return;
    };

    const fetchWordBookQuizView = async () => {
        try {
            const resData = await getWordBookQuizView();
            setQuestionData(resData.result);
            setQuestionAnswer(resData.result.answer)
            fetchWordBookView(resData.result.answer);
        } catch (err) {
            console.log(err);
        }
    };

    const getWordBookView = async (item) => {
        let _return = {
            status: false,
            result: {},
            rowCount: 0,
        };
        try {
            let sortWord = []
            item.forEach(element => {
                sortWord.push(element.code)
            });
            const { data } = await WordBookAllView({
                data: {
                    customer: customerId,
                    limit: 365,
                    myWord: true,
                    sortWord: sortWord
                }
            });
            if (data.resultCode === "20000") {
                const resData = data.resultData;

                _return.status = true;
                _return.result = resData;
                _return.rowCount = data.rowCount;
            } else {
                navigate("/word-book-main");
            }
        } catch (e) {
            console.log(e);
            return _return;
        }
        return _return;
    };

    const fetchWordBookView = async (item) => {
        try {
            const resData = await getWordBookView(item);
            let tmp = resData.result
            tmp.forEach(element => {
                element.isSelected = false
            });
            setWordBookAll(tmp);
            setWordBookData(tmp);
        } catch (err) {
            console.log(err);
        }
    };

    const showDrawer = (index) => {
        setIsAns(false);
        setOpen(true);

    };

    const onClose = () => {
        if (isAns) {
            setOpen(false);
        } else {
            setOpenPopup(true)
        }

    };

    const onClickItem = (index) => {
        let _wordBookData = _.cloneDeep(wordBookData)
        if (answerData.length < questionAnswer.length) {
            let _answerData = []
            _wordBookData[index].isSelected = !_wordBookData[index].isSelected
            setWordBookData(_wordBookData)
            _wordBookData.forEach(element => {
                if (element.isSelected) {
                    _answerData.push(element)
                }
            });
            setAnswerData(_answerData)
        } else {
            if (_wordBookData[index].isSelected) {
                let check = answerData.filter(e => e.name === _wordBookData[index].name)
                _wordBookData[index].isSelected = !_wordBookData[index].isSelected
                let _answerData = _.cloneDeep(answerData)
                _answerData.splice(check, 1)
                setAnswerData(_answerData)
                setWordBookData(_wordBookData)
            }
        }

    }

    const resetAns = () => {
        let _wordBookData = _.cloneDeep(wordBookAll)
        setWordBookData(_wordBookData)
        setAnswerData([])
        setIsAns(false)
        setOpenPopup(false)
        setOpenPopupError(false)
        setOpen(false)
    }


    const handleAnswer = () => {
        const check = reorderArray();
        if (questionAnswer.length !== answerData.length) {
            setOpenPopup(true)
        }
        else if (!check) {
            setOpenPopupError(true)
        } else {
            setIsAns(true)
            setOpen(false)
        }

    }

    const reorderArray = () => {
        let refArr = _.cloneDeep(questionAnswer)
        let targetArr = _.cloneDeep(answerData)
        const sortedRef = [...refArr].sort(function (a, b) { return a.code - b.code });
        const sortedTarget = [...targetArr].sort(function (a, b) { return a.code - b.code });

        console.log(answerData)
        console.log(questionAnswer)

        let check = true

        if (questionAnswer.length !== answerData.length) {
            check = false;
        } else {
            for (let i = 0; i < sortedRef.length; i++) {
                if (sortedRef[i].code !== sortedTarget[i].code) {
                    check = false;
                }
            }
            if (check) {
                let tmp = _.cloneDeep(answerData)
                answerData.forEach(element => {
                    let index = questionAnswer.findIndex(e => e.code === element.code)
                    tmp[index] = {
                        name: questionAnswer[index].name,
                        code: questionAnswer[index].code,
                        count: 0,
                        img: questionAnswer[index].imgColor,
                        isSelected: true
                    }
                });
                setAnswerData(tmp);
            }

        }
        return check;
    };


    const submitAns = async () => {
        try {
            const { data } = await WordBookAnswer({
                data: {
                    customer: customerId,
                    wordBookQuiz: quizId
                }
            });
            if (data.resultCode === "20000") {
                if (data.resultData.earnHeart > 0) {
                    setPointType('heart')
                    setPointEarn(data.resultData.earnHeart)
                } else {
                    setPointType('point')
                    setPointEarn(data.resultData.earnPoint)
                }

                setOpenPopupSuccess(true)
            }
        } catch (error) {

        }
    }


    return (
        <div>
            <GetCurrentPoint />
            <Helmet>
                <title>โคอะลา มาร์ช</title>
                <meta name="title" content="โคอะลา มาร์ช" />
                <meta name="description" content="" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="โคอะลา มาร์ช" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="" />
            </Helmet>

            <div id="pageWordBookAnswer">
                {/* <!-- Content Page --> */}
                <main>
                    <div className="wrapContent">
                        <div className="bTop">
                            <div style={{ display: 'flex', marginTop: '5px' }}>
                                <a className="btnGoBack" onClick={() => navigate(`/word-book-quiz?page=${currentPage}`)}>
                                </a>
                                <a className="btnGoHome" onClick={() => navigate('/profile')}>
                                </a>
                            </div>

                            <div className="divHeart">
                                <Image preview={false} src={heart}></Image>
                                <span>{newCurrentHeart}/10</span>
                                <a className="iconInfo" onClick={() => setTootip(true)}></a>
                                <div className="bTips" style={{ display: tootip ? 'block' : 'none' }} >
                                    <a className="btnCloseTips" onClick={() => setTootip(false)}></a>
                                    <p className="bold">เก็บหัวใจครบ 10 ดวง <br></br>เพื่อแลกของรางวัล</p>
                                    <p>
                                        เก็บสะสม Wordbook จากการสแกน สะสมคะแนน เพื่อตอบคำถามในกิจกรรม ตอบ 1 คำถาม รับไปเลย 1 ดวง!
                                    </p>
                                </div>
                            </div>
                        </div>
                        <section id="wordBookAnswer">
                            <div className="pContent">
                                <div className="pTop">
                                    <div className="pStar"><p>{questionData?.name}</p></div>
                                    <div className="pQuestion">
                                        <p>{questionData?.description}</p>
                                    </div>
                                </div>
                                <div className="pImage">
                                    {questionData && <Image preview={false} src={questionData.img}></Image>}
                                </div>
                                <div className="pAnswer">
                                    <div className="pInner">
                                        <p>แตะที่บิสกิตเพื่อเติมคำตอบ</p>
                                        <div className="pBiscuit">
                                            {!isAns ?
                                                <>
                                                    {questionAnswer.length > 0 && questionAnswer.map((item, index) => {
                                                        return (
                                                            <Image preview={false} src={item.imgGray} onClick={() => showDrawer(index)}></Image>
                                                        )
                                                    })}
                                                </>
                                                :
                                                <>
                                                    {answerData.length > 0 && answerData.map((item, index) => {
                                                        return (
                                                            <>
                                                                {item.isSelected ?
                                                                    <Image preview={false} src={item.img} onClick={() => showDrawer(index)}></Image>
                                                                    :
                                                                    <Image preview={false} src={item.imgGray} onClick={() => showDrawer(index)}></Image>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </>
                                            }

                                        </div>
                                        <div>
                                            <button className="btnAns" disabled={!isAns} onClick={() => submitAns()}>ส่งคำตอบ</button>
                                        </div>
                                    </div>

                                </div>

                            </div>

                            <Drawer
                                className="wordBookSelect"
                                placement='bottom'
                                closable={false}
                                onClose={onClose}
                                open={open}
                            >
                                <div className="pInner">
                                    <h2>คำตอบ:
                                        {questionAnswer.length > 0 && questionAnswer.map((item, index) => {
                                            return (
                                                <span> {item.name}</span>
                                            )
                                        })}
                                    </h2>
                                    <p>กดเลือกบิสกิตเพื่อเติมคำตอบ</p>
                                    <div className="pWordAll">
                                        {wordBookData && wordBookData.map((item, index) => {
                                            return (
                                                <div style={{ position: 'relative' }}>
                                                    <div className="wordCount" hidden={item.count <= 1}> {item.count}</div>
                                                    <Image className={item.isSelected ? 'selected' : 'unselected'} preview={false} src={item.isSelected ? item.imgShadow : item.img} onClick={() => onClickItem(index)}></Image>
                                                </div>
                                            )
                                        })}
                                    </div>
                                    <div className="pAnswer">
                                        <button className="btnAns" onClick={() => handleAnswer()}>เติมคำตอบ</button>
                                    </div>

                                </div>
                            </Drawer>

                        </section>

                    </div>
                </main>
            </div >

            <ModalCustom
                isOpen={openPopup}
                title='คุณยังตอบคำถามไม่เสร็จ ยืนยันจะออกหรือไม่?'
                confirmText="ยืนยัน"
                cancelTxt="เล่นต่อ"
                onOk={resetAns}
                onClose={() => setOpenPopup(false)}
            />

            <ModalCustom
                isOpen={openPopupError}
                title='คำตอบดูเหมือนยังไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง'
                confirmText="ตอบอีกครั้ง"
                cancelTxt="ไว้ทีหลัง"
                onOk={resetAns}
                onClose={() => setOpenPopupError(false)}
            />

            <ModalSucces
                pointType={pointType}
                pointEarn={pointEarn}
                isOpen={openPopupSuccess}
                onOk={() => navigate(`/word-book-quiz?page=${currentPage}`)}
                onClose={() => navigate('/word-book-main')}
            />


        </div >
    );
};

export default WordBookQuizAnswer;
